import React, { VFC } from "react";
import styled from "styled-components";
import { DictionaryItem } from "~/models/dictionaryItem";
import { Topic } from "~/models/topic";
import TagSubTopicItem from "./tags/SubTopicItem";
import TagTopicItem from "./tags/TopicItem";

interface Props {
  dictionaryItems: DictionaryItem[];
  host?: string;
  isTextUnderline?: boolean;
  locale?: string;
  marginBottom?: number;
  marginRight?: number;
  subtopicContainerRef?: React.MutableRefObject<HTMLDivElement | null>;
  topic: Topic;
}

const TopicBreadcrumb: VFC<Props> = ({
  dictionaryItems,
  host,
  isTextUnderline = false,
  locale,
  marginBottom,
  marginRight,
  subtopicContainerRef,
  topic,
}) => {
  if (!topic) {
    return <></>;
  }

  return (
    <>
      <Wrapper className="hide-scrollbar">
        <TagTopicItem
          host={host}
          isTextUnderline={isTextUnderline}
          locale={locale}
          marginBottom={marginBottom}
          marginRight={marginRight}
          topic={topic}
        />
        {dictionaryItems?.length > 0 && (
          <>
            <SubTopicTagList ref={subtopicContainerRef}>
              {dictionaryItems?.map((dictionary) => {
                return (
                  <TagSubTopicItem
                    key={dictionary.id}
                    host={host}
                    isTextUnderline={isTextUnderline}
                    locale={locale}
                    marginBottom={marginBottom}
                    marginRight={marginRight}
                    dictionaryItem={dictionary}
                    topic={topic}
                  />
                );
              })}
            </SubTopicTagList>
          </>
        )}
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  overflow: scroll;
  white-space: nowrap;
`;

const SubTopicTagList = styled.div`
  display: inline-flex;
  gap: 12px;
`;

export default TopicBreadcrumb;
